// @ts-nocheck
import { Platform } from "react-native";
import DollarIcon from "../assets/images/notification/dollar-blue.svg";
import DollarIconRead from "../assets/images/notification/dollar-grey.svg";
import DocIcon from "../assets/images/notification/doc-blue.svg";
import DocIconRead from "../assets/images/notification/doc-grey.svg";
import BellIcon from "../assets/images/notification/bell-blue.svg";
import BellIconRead from "../assets/images/notification/bell-grey.svg";
import UpArrow from "../assets/images/arrow-up.svg";
import Downarrow from "../assets/images/arrow-down.svg";
import NotificationIcon from "../assets/images/notification/notification-bell.svg";
import {
  BELL_BLUE_ICON,
  BELL_GREY_ICON,
  DOCS_BLUE_ICON,
  DOCS_GREY_ICON,
  DOLLAR_BLUE_ICON,
  DOLLAR_GREY_ICON,
} from "./IMAGES";
import { NotificationType } from "@lib/utilities/Constants";
import * as IMAGES from "./IMAGES";

export const notificationIconImage = () => {
  if (Platform.OS == "web") {
    return NotificationIcon;
  } else {
    return require("../assets/images/notification/notification-bell.png");
  }
};

const getNotificationIconForWeb = (type: number, isRead: boolean) => {
  if (type == NotificationType.docs) {
    return isRead ? DocIconRead : DocIcon;
  } else if (type == NotificationType.payment) {
    return isRead ? DollarIconRead : DollarIcon;
  } else {
    return isRead ? BellIconRead : BellIcon;
  }
};

const getNotificationIconForMobile = (type: number, isRead: boolean) => {
  if (type == NotificationType.docs) {
    return isRead ? DOCS_GREY_ICON : DOCS_BLUE_ICON;
  } else if (type == NotificationType.payment) {
    return isRead ? DOLLAR_GREY_ICON : DOLLAR_BLUE_ICON;
  } else {
    return isRead ? BELL_GREY_ICON : BELL_BLUE_ICON;
  }
};

export const notificationAsset = (type: number, isRead: boolean) =>
  Platform.OS == "web"
    ? getNotificationIconForWeb(type, isRead)
    : getNotificationIconForMobile(type, isRead);

export const getBranPaymentIcon = (iconType: string) => {
  switch (iconType) {
    case "bank":
      return IMAGES.BANK_PAYMENTS_ICON;
    case "mail":
      return IMAGES.MAIL_PAYMENTS_ICON;
    case "card":
      return IMAGES.CARD_PAYMENTS_ICON;
    default:
      return IMAGES.CARD_PAYMENTS_ICON;
  }
};
